<template>
    <div id="footer">
        <mt-tabbar v-model="selected" fixed v-show="$route.meta.navShow">
            <mt-tab-item id="message">
                消息<span v-if="messageCount>0">({{ messageCount }})</span>
                <img slot="icon" :src="img1">
            </mt-tab-item>
            <mt-tab-item id="community">
                社区
                <img slot="icon" :src="img2">
            </mt-tab-item>
            <mt-tab-item id="my">
                我的
                <img slot="icon" :src="img3">
            </mt-tab-item>
        </mt-tabbar>
    </div>
</template>
<style>
    .mint-tabbar > .mint-tab-item.is-selected{
        background:none;
        background-color:none!important;
    }

    .mint-tabbar{
        background:#fff;
        border-top:1px solid #dedede;
    }
    .is-selected .mint-tab-item-label{
        color: #ffcb01;
        font-weight:800;
    }

</style>
<script>
    export default {
        data() {
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                selected:this.$route.meta.tab,
                img1: "static/message.png",
                img2: "static/community-off.png",
                img3: "static/my-off.png",
            }
        },

        props:{
            messageCount:Number
        },

        watch:{
            selected:{
                handler(){
                   this.changeTab(this.selected);
                }
            },
            '$route' (to, from) {
                console.log(to.meta.tab);
                this.selected = to.meta.tab;
                this.changeTab(to.meta.tab);

           /*     if(to.meta.tab){
                    this.$axios.get("/message/count?openid="+this.openid).then(data => {
                        if(data.data.code === 'OK'){
                            this.messageCount = data.data.data;
                        }

                    });
                }*/

            }
        },
        methods: {
            changeTab(tab) {
                if (tab === 'message') {
                    this.img1 = "static/message.png";
                    this.img2 = "static/community-off.png";
                    this.img3 = "static/my-off.png";

                    this.$router.push('/');
                }

                if (tab === 'community') {
                    this.img1 = "static/message-off.png";
                    this.img2 = "static/community.png";
                    this.img3 = "static/my-off.png";

                    this.$router.push('/community');
                }

                if (tab === 'my') {
                    this.img1 = "static/message-off.png";
                    this.img2 = "static/community-off.png";
                    this.img3 = "static/my.png";

                    this.$router.push('/my');
                }
            },
        },
        created(){
            this.changeTab(this.$route.meta.tab);
        /*    if(this.$route.meta.tab){
                this.$axios.get("/message/count?openid="+this.openid).then(data => {
                    if(data.data.code === 'OK'){
                        this.messageCount = data.data.data;
                    }

                });
            }*/

        }

    }
</script>



// WEBPACK FOOTER //
// src/components/footer.vue